<template>
  <div class="flex-align" style="margin-top:8px;gap:8px">
    <select class="input-border" v-model="status">
      <option v-for="item in status_arr" :key="`status-${item.value}`" :value="item.value">{{ item.label }}</option>
    </select>
    <button v-if="value.status !== status" class="button is-primary" style="width:80px" @click="clickStatus">변경</button>
  </div>
</template>

<script>
  export default {
    name: "StatusButton",
    props: {
      value: {
        Object
      }
    },
    created() {
      this.status = this.value.status;
      this.$axios.get(this.getUrl(`shipagency/order/status`)).then(res=>{
        if(res.status === 200){
          this.status_arr = res.data;
        }
      })
    },
    data() {
      return {
        status: 100,
        status_arr: []
      }
    },
    methods: {
      clickStatus() {
        // 배송중으로 변경시, 송장번호 입력 확인
        if(this.status === 103 && this.value.info.some(i => !i.parcel_number || i.parcel_number === '')) {
          this.toast('송장번호(HAWB)가 모두 입력되지 않았습니다.');
          return;
        }

        this.$axios.patch(this.getUrl(`shipagency/order/${this.$route.query.id}`), { status: this.status }).then(res => {
          if(res.status === 200) {
            this.value.status = this.status;
            this.value.status_kor = this.status_arr.find(i => i.value === this.status).label;
          }
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  select
    width 150px
</style>
